/**
 * The Pack – Cart Bundle Checkout Interceptor
 *
 * Add this script to your cart page (or theme.liquid scoped to the cart page).
 * It intercepts the Checkout button, sends the cart to the Cloudflare Worker
 * if bundle items are present, and redirects to the discounted Draft Order URL.
 *
 * HOW TO ADD TO YOUR THEME:
 *   Option A (Recommended): In theme.liquid, add this script only on the cart page:
 *     {% if template == 'cart' %}
 *       <script src="{{ 'cart-bundle-checkout.js' | asset_url }}" defer></script>
 *     {% endif %}
 *
 *   Option B: Paste the contents directly into your cart.liquid template
 *   inside a <script> tag at the bottom.
 */

(function () {

  // ── IMPORTANT: Replace this with your deployed Cloudflare Worker URL ──
  const WORKER_URL = "https://bundle-backend.siajiazheng.workers.dev"

  // ─────────────────────────────────────────────────────────────────────────

  function init() {
    // Find checkout buttons — this selector covers most Shopify themes.
    // If your theme's checkout button isn't being intercepted, inspect the
    // button element and add its selector here.
    const checkoutButtons = document.querySelectorAll(
      '[name="checkout"], ' +
      'button[type="submit"].cart__checkout-button, ' +
      'input[name="checkout"], ' +
      '#checkout'
    )

    if (checkoutButtons.length === 0) {
      console.warn("[Bundle] No checkout button found. Script may need a selector update.")
      return
    }

    checkoutButtons.forEach(btn => {
      // For buttons inside a <form>, intercept the form submit instead
      const form = btn.closest("form")
      if (form && !form.dataset.bundleIntercepted) {
        form.dataset.bundleIntercepted = "true"
        form.addEventListener("submit", handleCheckout)
      } else if (!form) {
        btn.addEventListener("click", handleCheckout)
      }
    })

    console.log("[Bundle] Checkout interceptor ready.")
  }

  async function handleCheckout(e) {
    e.preventDefault()

    const checkoutButtons = document.querySelectorAll(
      '[name="checkout"], button[type="submit"].cart__checkout-button, input[name="checkout"], #checkout'
    )

    // Show loading state
    checkoutButtons.forEach(btn => {
      btn.disabled = true
      if (btn.tagName !== "INPUT") btn.innerText = "Processing..."
    })

    try {
      // Fetch the current cart
      const cartRes = await fetch("/cart.js")
      const cart    = await cartRes.json()

      // Check if any items have a _bundleId property
      const hasBundleItems = cart.items.some(
        item => item.properties && item.properties._bundleId
      )

      if (!hasBundleItems) {
        // No bundle items — proceed with normal Shopify checkout
        window.location.href = "/checkout"
        return
      }

      // Send cart to the Cloudflare Worker
      const workerRes = await fetch(WORKER_URL, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(cart),
      })

      const data = await workerRes.json()

      if (!workerRes.ok || !data.checkoutUrl) {
        throw new Error(data.error || "Worker did not return a checkout URL.")
      }

      // Redirect to the discounted Draft Order checkout
      window.location.href = data.checkoutUrl

    } catch (err) {
      console.error("[Bundle] Checkout error:", err.message)

      // Restore buttons so the customer can try again
      checkoutButtons.forEach(btn => {
        btn.disabled = false
        if (btn.tagName !== "INPUT") btn.innerText = "Check out"
      })

      alert(
        "There was a problem applying your bundle discount. " +
        "Please try again, or contact us if the issue continues."
      )
    }
  }

  // Run after the DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }

})()